<span class="text-black"> {{ 'auth_step' | translate }} </span>
<span class="text-black font-size-normal">{{ step }} {{ 'auth_of' | translate }} {{ totalSteps }}</span>
